export const elementColors = {
    H: '#FFFFFF',  // White
    He: '#58C4DD', // Sky blue
    Li: '#FFA500', // Orange
    Be: '#800080', // Purple
    B: '#FF0000',  // Red
    C: '#000000',  // Black
    N: '#0000FF',  // Blue
    O: '#FF0000',  // Red
    F: '#00FF00',  // Lime green
    Ne: '#00008B', // Dark blue
    Na: '#FFD700', // Gold
    Mg: '#8B4513', // Saddle brown
    Al: '#FA8072', // Salmon
    Si: '#4682B4', // Steel blue
    P: '#FFA500', // Chocolate
    S: '#FFFF00', // Yellow
    Cl: '#00FA9A', // Medium spring green
    Ar: '#4B0082', // Indigo
    K: '#FF4500', // Orange red
    Ca: '#2E8B57', // Sea green
    Sc: '#EAA2A2', // Silver
    Ti: '#F8C2D1', // Grey metallic
    V: '#A6A6AB',  // Chrome
    Cr: '#8A99C7', // Violet
    Mn: '#9C7AC7', // Lilac
    Fe: '#E06633', // Iron rust
    Co: '#F090A0', // Soft pink
    Ni: '#50D050', // Emerald
    Cu: '#C88033', // Copper
    Zn: '#7D80B0', // Dull blue
    Ga: '#C28F8F', // Faded red
    Ge: '#668F8F', // Sea foam
    As: '#BD80E3', // Medium purple
    Se: '#FFA100', // Amber
    Br: '#A62929', // Brick red
    Kr: '#5CB8D1', // Sky blue
    Rb: '#702EB0', // Deep purple
    Sr: '#00FF00', // Bright green
    Y: '#94FFFF',  // Pale cyan
    Zr: '#94E0E0', // Pale blue
    Nb: '#73C2C9', // Peacock blue
    Mo: '#54B5B5', // Medium turquoise
    Tc: '#3B9E9E', // Teal
    Ru: '#248F8F', // Dark cyan
    Rh: '#0A7D8C', // Darker cyan
    Pd: '#006985', // Navy
    Ag: '#C0C0C0', // Silver
    Cd: '#FFD98F', // Pale orange
    In: '#A67573', // Reddish brown
    Sn: '#668080', // Desaturated cyan
    Sb: '#9E63B5', // Medium violet
    Te: '#D47A00', // Dark orange
    I: '#940094',  // Indigo
    Xe: '#429EB0', // Cerulean
    Cs: '#57178F', // Violet
    Ba: '#00C900', // Vivid green
    La: '#70D4FF', // Bright light blue
    Ce: '#FFFFC7', // Very pale yellow
    Pr: '#D9FFC7', // Pale green
    Nd: '#C7FFC7', // Pale light green
    Pm: '#A3FFC7', // Very pale (mostly white) teal
    Sm: '#8FFFC7', // Pale teal
    Eu: '#61FFC7', // Aquamarine
    Gd: '#45FFC7', // Bright mint green
    Tb: '#30FFC7', // Medium spring green
    Dy: '#1FFFC7', // Turquoise
    Ho: '#00FF9C', // Aquamarine
    Er: '#00E675', // Mint green
    Tm: '#00D452', // Strong green
    Yb: '#00BF38', // Dark lime green
    Lu: '#00AB24', // Dark green
    Hf: '#4DC2FF', // Neon blue
    Ta: '#4DA6FF', // Azure
    W: '#2194D6', // Blue jeans
    Re: '#267DAB', // Dark cerulean
    Os: '#266696', // Celtic blue
    Ir: '#175487', // Queen blue
    Pt: '#D0D0E0', // Light gray
    Au: '#FFD123', // Golden
    Hg: '#B8B8D0', // Lavender gray
    Tl: '#A6544D', // Redwood
    Pb: '#575961', // Manatee
    Bi: '#9E4FB5', // Purple plum
    Po: '#AB5C00', // Deep orange
    At: '#754F45', // Dark brown
    Rn: '#428296', // Blue yonder
    Fr: '#420066', // Purple navy
    Ra: '#007D00', // Office green
    Ac: '#70ABFA', // Bright light blue
    Th: '#00BAFF', // Capri
    Pa: '#00A1FF', // Vivid sky blue
    U: '#008FFF',  // Deep sky blue
    Np: '#0080FF', // Azure
    Pu: '#006BFF', // Blue ribbon
    Am: '#545CF2', // Slate blue
    Cm: '#785CE3', // Medium slate blue
    Bk: '#8A4FE3', // Lavender purple
    Cf: '#A136D4', // Purple
    Es: '#B31FD4', // Orchid
    Fm: '#B31FBA', // Medium orchid
    Md: '#B30DA6', // Medium purple
    No: '#BD0D87', // Pale violet red
    Lr: '#C70066', // Rose red
    Rf: '#CC0059', // Red
    Db: '#D1004F', // Red-pink
    Sg: '#D90045', // Ruby red
    Bh: '#E00038', // Crimson
    Hs: '#E6002E', // Red-orange
    Mt: '#EB0026', // Red-pigment
    // The rest would continue as per the remaining elements
};
